module.exports = __webpack_public_path__ + "img/ips.8daf41d8.jpg";